import FormConfig from './ConfigurationFormConfig';
import AjaxUtility from '../Utility/AjaxUtility';
import MathUtility from '../Utility/MathUtility';
// Removed map imports; map handling moved to LocationManager
import LocationManager from './Modules/LocationManager';
// NEW: Area managers extracted from this file (see comments below)
import AreaManagerLegacy from './Modules/AreaManagerLegacy';
import AreaManagerNew from './Modules/AreaManagerNew';
import FOrtQuestionManager from './Modules/FOrtQuestionManager';
import KiWizardManager from './Modules/KiWizardManager';
import FKWizardManager from './Modules/FKWizardManager';
import FMethodeManager from './Modules/FMethodeManager';

export default class ConfigurationForm {

	constructor() {
		this.initializing = true;
		this.form = $(FormConfig.selectors.configurationForm);
		this.state = {
			country: FormConfig.values.countries.GERMANY,
			propertyType: null,
			surfaceCategory: null
		};
		this.locationManager = new LocationManager(this.form, this.state);
		// Initialize area managers (legacy DWA-A 138 and new DWA-A 138-1)
		// Keep behaviour 1:1; managers call back into this for updateFormData/updateSummary
		// CHANGE: logic moved out of this class
		this.areaManagerLegacy = new AreaManagerLegacy(this.form, this.state, this);
		this.areaManagerNew = new AreaManagerNew(this.form, this.state, this);
		// VSO-409: fOrt question wizard manager (Step 5)
		this.fOrtQuestionManager = new FOrtQuestionManager(this.form, this.state, this);
		// VSO-409: remaining wizard managers (Steps 1/3/6)
		this.kiWizardManager = new KiWizardManager(this.form, this.state, this);
		this.fkWizardManager = new FKWizardManager(this.form, this.state, this);
		this.fMethodeManager = new FMethodeManager(this.form, this.state, this);
		// Continue only on form page
		if (this.form.length) {
			this.currentSlideIndex = 0;
			this.slideProgress = 0;
			this.slides = $(FormConfig.selectors.slides);
			this.configurationSummary = $(FormConfig.selectors.configurationSummary);
			this.formData = {};
			this.progressMeter = $(FormConfig.selectors.progressMeter);
			this.completionPercentage = 0;
			this.isEditMode = $(FormConfig.selectors.calculator).data('type') === 'edit';

			// CHANGE: coefficientStep moved to FormConfig.settings; host property removed
			this.areaTypeCount = $(FormConfig.selectors.areaTypeBlock).length;
			// CHANGE: areaTypeMax moved to FormConfig.settings; host property removed
			this.rcIndexInput = $(FormConfig.selectors.rcIndexInput);
			this.rcIndex = this.rcIndexInput.val();

			this.runoffTypes = {};

			this.customRunoffValueInput = $(FormConfig.selectors.customRunoffValueInput);
			this.customRunoffValueSignificand = $(FormConfig.selectors.customRunoffValueSignificand);
			this.customRunoffValueExponent = $(FormConfig.selectors.customRunoffValueExponent);
			this.runoffValueIndexNotationResult = $(FormConfig.selectors.runoffValueIndexNotationResult);
			this.weatherStation = $(FormConfig.selectors.weatherStation);
			this.nextSlideButton = $(FormConfig.selectors.nextSlideButton);
			this.scrollTarget = document.querySelector(FormConfig.selectors.nextSlideScrollTarget);

			this.slides.each((index, slide) => {
				$(slide).data('slideindex', index);
			});

			if (this.customRunoffValueSignificand.length && this.customRunoffValueExponent.length) {
				this.setCustomRunoffValueIndexNotation();
				this.resolveCustomRunoffValueIndexNotation();
			}

			$(FormConfig.selectors.areaTypeSelect).each((index, element) => {
				// CHANGE: delegate to AreaManagerLegacy
				this.areaManagerLegacy.fillAreaTypeData($(element), parseInt(element.value), true);
			});

			const resultMessageContainer = $(FormConfig.selectors.weatherStationCheckResult);
			if (resultMessageContainer.length > 0 && resultMessageContainer.html().length > 0) {
				resultMessageContainer.show();
			}

			if ($(FormConfig.selectors.groundReportFilesUploadHidden).prop('checked')) {
				this.activateGroundReportFilesUpload();
			}

			this.bindHandlers();

			// CHANGE: delegate to AreaManagerLegacy
			this.areaManagerLegacy.toggleRemoveButtons();

			// Initialize DWA-A 138-1 area handlers if the new UI is present
			// CHANGE: delegate to AreaManagerNew
			this.areaManagerNew.initAreaType1381Handlers();
			// VSO-409: Initialize fOrt question wizard block (Step 5)
			this.fOrtQuestionManager.init();
			// VSO-409: Initialize remaining wizard steps
			this.kiWizardManager.init();
			this.fkWizardManager.init();
			this.fMethodeManager.init();

			// fancybox settings
			$.fancybox.defaults = $.extend($.fancybox.defaults, {
				maxWidth: 1080,
				helpers: {
					overlay: {
						locked: false
					}
				}
			});

			$('.fancybox').not('.iframe').fancybox();

			$('.fancybox.iframe').fancybox({
				type: 'iframe'
			});

			// VSO-334: Prevent submit with ENTER
			this.form.keydown(function (event) {
				if (event.keyCode === 13) {
					event.preventDefault();
					return false;
				}
			});
		}
		this.initializing = false;
	}

	bindHandlers() {
		this.nextSlideButton.on('click', e => {
			e.preventDefault();
			this.nextSlide();
		});

		const formInputs = this.form.find('input, select, textarea');
		formInputs.on('change', e => {
			this.updateFormData(e.target);
		});
		formInputs.each((i, input) => {
			this.updateFormData(input, false);
		});

		// initial slideIndex Update
		if (this.isEditMode) {
			this.slideProgress = this.slides.length;
			$(FormConfig.selectors.progressButton).addClass('complete');
		} else {
			const lastSummary = $(FormConfig.selectors.configurationSummary).find('.summaryItem').eq(-1);
			const furthestSlide = $(`[data-property="${lastSummary.data('summaryproperty')}"]`).eq(0).parents(FormConfig.selectors.slides);
			if (furthestSlide.length) {
				this.slideProgress = furthestSlide.data('slideindex');
			}
		}

		const checkboxRoots = this.form.find(FormConfig.selectors.checkboxRoot);
		checkboxRoots.on('click', e => {
			const field = $(e.target).find('input').last()[0];
			if (field && !field.disabled) {
				// Trigger the native input click; the bound 'change' handler
				// will update formData and the summary. Avoid calling
				// updateFormData() here to prevent double processing
				// that caused duplicate entries (e.g., products) in the sidebar.
				field.click();
			}
		});

		const squareCheckboxes = this.form.find(FormConfig.selectors.squareCheckbox + ' input');
		squareCheckboxes.on('click', e => {
			const input = $(e.target);
			input.parent().toggleClass('checked');
		});

		this.form.find(FormConfig.selectors.checkboxTeaser)
			.on('click', e => {
				$(e.target).parents('.checkbox-inner-wrapper').find(FormConfig.selectors.checkboxRoot).click()
			});

		this.updateSummary();

		const infiltrationRadios = $(FormConfig.selectors.infiltrationType);
		infiltrationRadios.on('click', e => {
			this.infiltrationTypeChange(parseInt(e.target.value), true);
		});
		this.infiltrationTypeChange(parseInt(infiltrationRadios.filter(':checked').val()));

		const attenuationPlusCheckbox = $(FormConfig.selectors.attenuationPlusCheckbox);
		attenuationPlusCheckbox.on('click', e => {
			this.attenuationPlusChange($(FormConfig.selectors.attenuationPlusCheckbox));
		});
		this.attenuationPlusChange($(FormConfig.selectors.attenuationPlusCheckbox));

		this.customRunoffValueInput.hide();
		// show javascript based index notation input
		$(FormConfig.selectors.customRunoffValueIndexNotation).show();

		this.customRunoffValueSignificand
			.add(this.customRunoffValueExponent)
			.on('change keyup', e => {
				this.resolveCustomRunoffValueIndexNotation();
			});

		$(FormConfig.selectors.addAreaTypeButton).on('click', e => {
			e.preventDefault();

			// CHANGE: delegate to AreaManagerLegacy
			this.areaManagerLegacy.addAreaType();
			return false;
		});

		// Toggle area slide UI between DWA-A 138 and DWA-A 138-1 depending on guideline selection
		const guidelineRadios = this.form.find(FormConfig.selectors.newGuidelineRadios);
		guidelineRadios.on('change', () => {
			this.toggleAreaSlideByGuideline();
			this.clearSlides(
				guidelineRadios.parents(FormConfig.selectors.slides).nextAll(FormConfig.selectors.slides)
			);
		});
		// Initialize visibility on first load
		// Ensure this happens after form data has been initialized from inputs
		window.setTimeout(() => {
			this.toggleAreaSlideByGuideline();
			this.updateSummary();

			// Force update of all 138-1 related managers if guideline is active
			if (this.isGuideline1381Active()) {
				if (this.fOrtQuestionManager) this.fOrtQuestionManager.updateVisibility();
				if (this.kiWizardManager) this.kiWizardManager.updateVisibility();
				if (this.fkWizardManager) this.fkWizardManager.updateVisibility();
				if (this.fMethodeManager) this.fMethodeManager.updateVisibility();
			}
		}, 150);

		this.bindPermittedDischargeHandlers();
		// CHANGE: delegate area select binds to AreaManagerLegacy
		this.areaManagerLegacy.bindAreaTypeSelectHandlers();

		this.resilienceChange($(FormConfig.selectors.resilienceRadio + ':checked'));

		const assignedTeamSelect = $(FormConfig.selectors.assignedTeamSelect);
		assignedTeamSelect.on('change', e => {
			this.updateProcessorSelect(e.target.value);
		});

		const configurationSubmit = $(FormConfig.selectors.configurationSubmit);
		configurationSubmit.on('click', e => {
			if(!this.isValidSlide(this.getCurrentSlide())) {
				e.preventDefault();
				return false;
			}
			const citySelect = $(FormConfig.selectors.citySelect);
			// no weather station selected
			if (this.state.country === FormConfig.values.countries.GERMANY && citySelect[0].selectedIndex !== 0) {
				e.preventDefault();
				this.locationManager.checkWeatherStation(null, false, true);
				return false;
			}
		});

		const
			groundReportInfoStep1 = $(FormConfig.selectors.groundReportInfoStep1),
			groundReportInfoStep2 = $(FormConfig.selectors.groundReportInfoStep2),
			activateGroundReportFilesUploadButton = $(FormConfig.selectors.activateGroundReportFilesUploadButton),
			confirmGroundReportFilesUpload = $(FormConfig.selectors.confirmGroundReportFilesUpload),
			cancelGroundReportFilesUpload = $(FormConfig.selectors.cancelGroundReportFilesUpload);

		activateGroundReportFilesUploadButton.on('click', e => {
			e.preventDefault();
			groundReportInfoStep1.hide();
			groundReportInfoStep2.show();
			confirmGroundReportFilesUpload.show();
			$.fancybox.update();

			confirmGroundReportFilesUpload.on('click', e => {
				e.preventDefault();
				confirmGroundReportFilesUpload.off('click');
				confirmGroundReportFilesUpload.hide();
				this.activateGroundReportFilesUpload();
				$.fancybox.close();
			});
		});
		cancelGroundReportFilesUpload.on('click', e => {
			e.preventDefault();
			confirmGroundReportFilesUpload.off('click');
			this.deactivateGroundReportFilesUpload();
			groundReportInfoStep2.hide();
			groundReportInfoStep1.show();
			$.fancybox.update();
		});

		const fancyboxClosers = $('.closeFancybox');
		fancyboxClosers.on('click', e => {
			e.preventDefault();
			$.fancybox.close();
		});

		const clientTypeSelect = $(FormConfig.selectors.clientTypeSelect);
		clientTypeSelect.on('change', e => {
			this.customerTypeBasedToggles(parseInt(clientTypeSelect.val()));
		});
		this.customerTypeBasedToggles(parseInt(clientTypeSelect.val()));

		const grafPartnerCheckbox = $(FormConfig.selectors.grafPartnerCheckbox);
		grafPartnerCheckbox.on('change', e => {
			this.grafPartnerCheckboxToggle(grafPartnerCheckbox.prop('checked'));
		});
		this.grafPartnerCheckboxToggle(grafPartnerCheckbox.prop('checked'));

		this.progressButtons = $(FormConfig.selectors.progressButton);
		this.progressButtons.on('click', e => {
			e.preventDefault();
			const category = $(e.target).data('slidecategory'),
				firstMatchingSlide = this.form.find(`[data-category="${category}"]`).eq(0),
				slideIndex = parseInt(firstMatchingSlide.data('slideindex'));

			if (slideIndex <= this.slideProgress) {
				this.goToSlide(slideIndex);
			}
		});

		$(FormConfig.selectors.backButton).on('click', e => {
			e.preventDefault();
			this.prevSlide();
		});

		$(FormConfig.selectors.startCalculatorButton).on('click', e => {
			e.preventDefault();
			$(FormConfig.selectors.inquiryIntro).hide();
			$(FormConfig.selectors.calculator).show();
		});

		$('.soilType').on('change', e => {
			const required = $(e.target).data('furtherrequire') || false;
			$('#customRunoffValueSignificand').prop('required', required);

			if (!required) {
				// Clear custom values from formData if we switched back to a predefined soil type
				const category = $(e.target).parents(FormConfig.selectors.slides).data('category');
				const customProperty = $('#customRunoffValueSignificand').data('property');

				if (category && customProperty && this.formData[category] && this.formData[category].hasOwnProperty(customProperty)) {
					delete this.formData[category][customProperty];
				}

				// Also clear the inputs to stay consistent
				this.customRunoffValueInput.val('');
				this.customRunoffValueSignificand.val('');
				if (this.customRunoffValueExponent.length && this.customRunoffValueExponent[0].options) {
					this.customRunoffValueExponent[0].selectedIndex = 0;
				}
				this.resolveCustomRunoffValueIndexNotation();

				this.updateSummary();
			}
		});

		const selectedPropertyType = $(FormConfig.selectors.propertyType).filter(':checked');
		if(selectedPropertyType) {
			this.state.propertyType = parseInt(selectedPropertyType.val());
		}
		$(FormConfig.selectors.propertyType).on('click', e => {
			this.state.propertyType = parseInt($(e.currentTarget).val());
			this.areaManagerNew.toggleAreaCategorizationRows();
			this.clearInputs(
				$(FormConfig.selectors.areaCategorizationDisplayToggle).add(FormConfig.selectors.areacategorizationInput)
			);
		});
	}

	// Helper: enable/disable all inputs in a container
	setInputsDisabled($container, disabled) {
		$container.find('input, select, textarea').each((i, el) => {
			const $el = $(el);
			// Never disable Extbase/Fluid security fields.
			const name = String($el.attr('name') || '');
			if (name.indexOf('__trustedProperties') !== -1 || name.indexOf('__referrer') !== -1) {
				return;
			}
			if ($el.data('infiltrationnotpossible') !== 1) {
				$el.prop('disabled', disabled);
			}
			if (disabled) {
				if ($el.prop('required')) {
					$el.data('prop-required', true);
				}

				$el.removeClass('error');
				$el.removeAttr('required');
			} else {
				// Restore required attribute if data-required is set
				if ($el.data('required') || $el.data('prop-required')) {
					$el.prop('required', true);
				}
			}
		});
	}

	// Show correct area slide variant depending on selected guideline (0 = DWA-A 138, 1 = DWA-A 138-1)
	toggleAreaSlideByGuideline() {
		let selected = this.form.find(FormConfig.selectors.newGuidelineRadios + ':checked');

		// Fallback for edit mode if radio binding failed in Fluid: check data attribute on container
		if (!selected.length) {
			const $container = $('.flex-container.flex-wrap[data-initial-new-guideline]');
			if ($container.length && $container.attr('data-initial-new-guideline') !== '') {
				const initialValue = $container.attr('data-initial-new-guideline');
				const $radio = this.form.find(FormConfig.selectors.newGuidelineRadios + '[value="' + initialValue + '"]');
				if ($radio.length) {
					$radio.prop('checked', true);
					selected = $radio;
				}
			}
		}

		const value = selected.length ? parseInt(selected.val(), 10) : 0;
		const $area138 = $('#areaGuideline138');
		const $area1381 = $('#areaGuideline1381');

		if (value === 1) {
			$area138.hide();
			this.setInputsDisabled($area138, true);
			$area1381.show();
			this.setInputsDisabled($area1381, false);

			$('.guideline138').hide();
			$('.newGuideline138-1').show();

			// Switch data-property for summary sidebar
			this.form.find('[data-property1381]').each((i, el) => {
				const $el = $(el);
				const category = $el.parents(FormConfig.selectors.slides).data('category');
				const oldProperty = $el.attr('data-property');

				if (!$el.attr('data-property-orig')) {
					$el.attr('data-property-orig', oldProperty);
				}
				const newProperty = $el.attr('data-property1381');
				$el.attr('data-property', newProperty);
				$el.data('property', newProperty); // VSO-409: Update jQuery data cache, otherwise old name stays in sidebar

				// Clean up old property from formData
				if (category && oldProperty !== newProperty && this.formData[category]) {
					delete this.formData[category][oldProperty];
				}
			});
		} else {
			$area1381.hide();
			this.setInputsDisabled($area1381, true);
			$area138.show();
			this.setInputsDisabled($area138, false);

			$('.newGuideline138-1').hide();
			$('.guideline138').show();

			// Restore data-property for summary sidebar
			this.form.find('[data-property-orig]').each((i, el) => {
				const $el = $(el);
				const category = $el.parents(FormConfig.selectors.slides).data('category');
				const oldProperty = $el.attr('data-property');
				const origProperty = $el.attr('data-property-orig');

				$el.attr('data-property', origProperty);
				$el.data('property', origProperty); // VSO-409: Restore jQuery data cache

				// Clean up property from formData
				if (category && oldProperty !== origProperty && this.formData[category]) {
					delete this.formData[category][oldProperty];
				}
			});
		}

		// Refresh formData to reflect property name changes in summary
		this.form.find('input, select, textarea').each((i, input) => {
			this.updateFormData(input, false);
		});

		// Clear any previous validation errors when switching variants to avoid stale blocking state
		const $areaSlide = $area138.parents(FormConfig.selectors.slides).first();
		if ($areaSlide && $areaSlide.length) {
			$areaSlide.find(FormConfig.selectors.errorList).hide().find('ul').html('');
			$areaSlide.find('input, select, textarea').removeClass('error');
		}
		// Recompute sidebar
		this.updateSummary();
		// VSO-409: toggle fOrt question wizard visibility along with guideline
		if (this.fOrtQuestionManager && typeof this.fOrtQuestionManager.updateVisibility === 'function') {
			this.fOrtQuestionManager.updateVisibility();
		}
		if (this.kiWizardManager && typeof this.kiWizardManager.updateVisibility === 'function') {
			this.kiWizardManager.updateVisibility();
		}
		if (this.fkWizardManager && typeof this.fkWizardManager.updateVisibility === 'function') {
			this.fkWizardManager.updateVisibility();
		}
		if (this.fMethodeManager && typeof this.fMethodeManager.updateVisibility === 'function') {
			this.fMethodeManager.updateVisibility();
		}
		// VSO-489: covers guideline switches, initial load and the forced legacy
		// guideline click on country change (state.country is updated by then)
		this.updateRainFrequencyDisabledState();
	}

	// Helper to detect if 138-1 UI is the currently selected path
	isGuideline1381Active() {
		const selected = this.form.find(FormConfig.selectors.newGuidelineRadios + ':checked');
		const value = selected.length ? parseInt(selected.val(), 10) : 0;
		// IMPORTANT: Do NOT couple guideline selection to any specific slide visibility.
		// Otherwise this returns false on non-area slides (parents hidden) and breaks downstream toggles.
		return value === 1;
	}

	// VSO-489: DWA-A 138-1 works with fixed rain frequencies for Mulden-Rigole (DE),
	// so the rainFrequency select must not be editable in that combination.
	// A disabled select is not submitted - safe here, since the 138-1 calculation
	// does not read rainFrequency and the PDF omits it for MuRi 138-1.
	updateRainFrequencyDisabledState() {
		const infiltrationType = parseInt($(FormConfig.selectors.infiltrationType + ':checked').val(), 10);
		const disable = this.state.country === FormConfig.values.countries.GERMANY
			&& infiltrationType === FormConfig.values.infiltrationType.TROUGH_RIGOLE
			&& this.isGuideline1381Active();

		const $rainFrequencySelect = $(FormConfig.selectors.rainFrequencySelect);
		if ($rainFrequencySelect.length && $rainFrequencySelect.prop('disabled') !== disable) {
			$rainFrequencySelect.prop('disabled', disable);
			// refresh the sidebar summary, which omits the rain frequency while disabled
			this.updateFormData($rainFrequencySelect[0]);
		}
	}

	// Area 138-1 logic moved to AreaManagerNew (Modules/AreaManagerNew.js)

	nextSlide() {
		this.goToSlide(this.currentSlideIndex + 1);
	}

	prevSlide() {
		this.goToSlide(this.currentSlideIndex - 1, -1);
	}

	goToSlide(index, fallback = 1) {
		if (
			(index < this.currentSlideIndex || this.isValidSlide(this.getCurrentSlide()))
			&& index >= 0 && index < this.slides.length
		) {
			this.slides.eq(this.currentSlideIndex).hide();
			const newSlide = this.slides.eq(index);
			newSlide.show();
			this.currentSlideIndex = index;
			this.slideProgress = Math.max(this.currentSlideIndex, this.slideProgress);
			const category = newSlide.data('category');

			// check if new slide has any displayable content
			// Ignore the error box when deciding if a slide has content. Otherwise,
			// a hidden slide (e.g., rigoleOnly content) with only a visible error box
			// would block navigation and show an empty error-only slide.
			const slideElements = this.slides.eq(index).children().not(FormConfig.selectors.errorList);
			if (
				!slideElements.toArray().some(element => window.getComputedStyle(element).display !== 'none')
				|| newSlide.data('skip') === true
			) {
				this.goToSlide(index + fallback, fallback);
			} else {
				// execute any slide specific actions
				const action = newSlide.data('action');
				if (action && typeof this[action] === "function") {
					this[action]();
				}

				this.progressButtons.removeClass('active');
				$(`${FormConfig.selectors.progressButton}[data-slidecategory="${category}"]`).addClass('active').addClass('complete');

				// scroll to top of slide
				this.scrollTarget.scrollIntoView({
					behavior: 'smooth'
				});
			}

			const progress = parseFloat(newSlide.data('progress'));
			if (progress && progress > this.completionPercentage) {
				this.completionPercentage = progress;
				this.progressMeter.css('width', `${progress}%`);
			}

			// is final slide
			if (index === this.slides.length - 1) {
				this.nextSlideButton.hide();
			} else {
				this.nextSlideButton.show();
			}

			return true;
		}
	}

	isValidSlide(slide) {
		const formFields = slide.find('input:visible, select:visible, textarea:visible'),
			errors = {},
			choiceRequired = formFields.eq(0).data('required');
		let valueSet = false;

		formFields.each((index, field) => {
			$(field).removeClass('error');
			if (
				field.required &&
				!field.checkValidity()
			) {
				this.addError(field, errors);
			}
			this.specialValidation(field, errors)
			if ((field.type === 'checkbox' || field.type === 'radio') && field.checked) {
				valueSet = true;
			}
		});

		if (choiceRequired && !valueSet) {
			this.addError(formFields[0], errors);
		}

		// VSO-409: Custom validation for Step 5 & 6
		if (this.isGuideline1381Active()) {
			if (slide.find('#fOrtStep5').is(':visible')) {
				if (this.fOrtQuestionManager && !this.fOrtQuestionManager.isValid()) {
					const $wizard = slide.find('#fOrtQuestionWizard');
					errors['fOrtQuestions'] = {
						message: $wizard.data('validationmessage') || 'Bitte beantworten Sie alle Fragen oder wählen Sie den Empfehlungswert.'
					};
				}
			}
			if (slide.find('#fMethodeStep6').is(':visible')) {
				if (this.fMethodeManager && !this.fMethodeManager.isValid()) {
					const $step = slide.find('#fMethodeStep6');
					errors['fMethodeSelection'] = {
						message: $step.data('validationmessage') || 'Bitte wählen Sie eine Methode und einen gültigen Faktor.'
					};
				}
			}
		}

		// Additional validation for DWA-A 138-1 area rows
		this.validateArea1381(slide, errors);

		this.displayErrors(slide, errors);

		return Object.keys(errors).length === 0;
	}

	clearSlides(slides) {
		slides.each((i, slide) => this.clearSlide($(slide)));
		this.updateSummary();
	}

	clearSlide(slide) {
		this.clearInputs(
			slide.find('input')
		);
		this.clearInputs(
			slide.find('select')
		);
	}

	clearInputs(inputs) {
		inputs.each((i, input) => {
			this.clearInput(input);
		})
	}

	clearInput(input) {
		// do not clear inputs on first form load or for inputs that were marked as 'keep'
		if (this.initializing || $(input).data('keep')) return;

		const category = $(input).parents(FormConfig.selectors.slides).data('category'),
			property = $(input).data('property');

		if (input.type === 'radio' || input.type === 'checkbox') {
			if (input.checked) input.checked = false;
		} else if (input.type === 'select-one') {
			input.selectedIndex = 0;
		} else if (input.type !== 'submit') {
			input.value = '';
		}

		if ($(input).parent('.checkbox-base').length) {
			if (input.type === 'radio') {
				this.toggleFormDataRadio(input, category, property, true);
			}
			if (input.type === 'checkbox') {
				this.toggleFormDataCheckbox(input, category, property);
			}
		} else {
			if (category && property && this.formData.hasOwnProperty(category) && this.formData[category].hasOwnProperty(property)) {
				this.formData[category][property] = [];
			}
		}

		this.updateFormData(input, false);
	}

	// Validate new DWA-A 138-1 area inputs
	validateArea1381(slide, errors) {
		try {
			// Only validate if the 138-1 UI is currently active (selected guideline and visible container)
			if (!this.isGuideline1381Active()) {
				return true;
			}
			const $container = $('#areaGuideline1381');
			if (!$container.length || !$container.is(':visible')) {
				return true;
			}
			const $rows = $container.find(FormConfig.selectors.areaTypeBlock1381).filter(':visible');
			if (!$rows.length) {
				return true;
			}

			$rows.each((i, row) => {
				const $row = $(row);
				const $cat = $row.find(FormConfig.selectors.surfaceCategory1381);
				const $typeSelect = $row.find(FormConfig.selectors.surfaceType1381Select);
				const $typeInput = $row.find(FormConfig.selectors.surfaceType1381Input);
				const $cm = $row.find(FormConfig.selectors.cm1381);
				const $area = $row.find(FormConfig.selectors.areaInput);
				const $areaCategorization = $row.find(FormConfig.selectors.areacategorizationInput);
				const $areaCategorizationDisplay = $row.find(FormConfig.selectors.areaCategorizationDisplayToggle);

				// Type logic
				if ($cat.length && String($cat.val()) === 'manual') {
					// Manual: require type text and Cm selection
					if ($typeInput.length && String(($typeInput.val() || '')).trim() === '') {
						this.addError($typeInput[0], errors, $typeInput.data('validationmessage'));
					}
					if ($cm.length && (!$cm.val() || String($cm.val()).trim() === '')) {
						this.addError($cm[0], errors, $cm.data('validationmessage'));
					}
				} else {
					// Regular: selects are always prefilled → no additional validation necessary here
				}

				// Area must be > 0
				if ($area.length) {
					const raw = String(($area.val() || '')).replace(',', '.');
					const num = parseFloat(raw);
					if (!isFinite(num) || num <= 0) {
						this.addError($area[0], errors, $area.data('validationmessage'));
					}
				}

				if ($areaCategorization.length) {
					const cat = parseInt($areaCategorization.val());
					if (isNaN(cat) || cat <= 0) {
						this.addError($areaCategorizationDisplay[0], errors, $areaCategorization.data('validationmessage'));
					}
				}
			});
			return Object.keys(errors).length === 0;
		} catch (e) {
			// Do not block navigation in case of unexpected issues
			return true;
		}
	}

	specialValidation(field, errors) {
		if (
			field.id === 'availableLength' &&
			parseFloat(field.value) < parseFloat($('#availableWidth').val())
		) {
			return this.addError(field, errors);
		}

		if (
			field.id === 'customRunoffValueSignificand' &&
			$('.soilType[data-furtherrequire]').prop('checked')
		) {
			const customRunoffValue = this.resolveCustomRunoffValueIndexNotation(true);
			if (customRunoffValue > 0.001 || customRunoffValue < 0.000001) {
				return this.addError(field, errors);
			}
		}

		if (
			field.id === 'kiSignificand' &&
			this.isGuideline1381Active() &&
			this.kiWizardManager.isKiManual() &&
			!this.kiWizardManager.isKiInPermissableRange()
		) {
			return this.addError(field, errors);
		}

		if ($(field).hasClass('fKInput') && this.isGuideline1381Active()) {
			const raw = String(field.value || '').trim().replace(',', '.');
			const value = parseFloat(raw);
			// 0.03 to 1.00, numerisch
			if (isNaN(value) || value < 0.03 || value > 1.0) {
				return this.addError(field, errors);
			}
		}

		if (
			field.id === 'propertyZip'
		) {
			// Delegate to LocationManager to respect shared state (country)
			if (!this.locationManager.validateZip(field, errors)) {
				this.locationManager.validateRcIndex(field, errors);
			}
		}

		return true;
	}

	addError(field, errors, errorMsg = null) {
		errors[field.name] = {
			message: errorMsg || $(field).data('validationmessage') || field.validationMessage || 'Bitte prüfen Sie Ihre Eingabe.'
		}
		$(field).addClass('error');
		return false;
	}

	displayErrors(slide, errors) {
		const errorBox = slide.find(FormConfig.selectors.errorList),
			errorList = errorBox.find('ul');

		if (Object.keys(errors).length) {
			errorBox.show();
			errorList.html('');

			for (let i in errors) {
				errorList.append(`<li>${errors[i].message}</li>`)
			}
		} else {
			errorBox.hide();
		}
	}

	getCurrentSlide() {
		return this.getSlide(this.currentSlideIndex);
	}

	getSlide(index) {
		return this.slides.eq(index);
	}

	updateFormData(field, updateSummary = true) {
		const category = $(field).parents(FormConfig.selectors.slides).data('category'),
			property = $(field).data('property'),
			special = $(field).data('special'),
			value = field.value;

		if (category && !this.formData.hasOwnProperty(category)) {
			this.formData[category] = {};
		}

		if (category && property && !this.formData[category].hasOwnProperty(property)) {
			if (field.type === 'checkbox') {
				this.formData[category][property] = [];
			} else {
				this.formData[category][property] = null;
			}
		}

		if (!category || !property) {
			this.specialFormDataUpdates(special, category, property, value, field);
			this.updateSummary();
			return;
		}

		if (category && property && field.type !== 'submit') {
			if (field.type === 'radio') {
				this.toggleFormDataRadio(field, category, property, updateSummary);
			} else if (field.type === 'checkbox') {
				this.toggleFormDataCheckbox(field, category, property);
			} else {
				this.formData[category][property] = value;
			}
		}

		this.specialFormDataUpdates(special, category, property, value, field);

		if (updateSummary) {
			this.updateSummary();
		}
	}

	specialFormDataUpdates(special, category, property, value = null, field = null) {
		// Only trigger special updates for checked radios (or non-radio fields)
		if (field && field.type === 'radio' && !field.checked) {
			return;
		}

		if (special === 'customRunoffValue') {
			this.formData[category][property] = `${this.resolveCustomRunoffValueIndexNotation()}`;
		}

		if (special === 'installationSituation') {
			this.formData[category][$(FormConfig.selectors.rainFrequencySelect).data('property')] = this.getSpecialInstallationSituationSummary();
		}

		if (special === 'roofArea') {
			// Ensure category bucket exists to avoid hasOwnProperty on undefined
			let effectiveCategory = category;
			if (!effectiveCategory) {
				// try to derive from field's slide, else fallback to 'area'
				if (field) {
					effectiveCategory = $(field).parents(FormConfig.selectors.slides).data('category') || 'area';
				} else {
					effectiveCategory = 'area';
				}
			}
			if (!this.formData.hasOwnProperty(effectiveCategory) || typeof this.formData[effectiveCategory] !== 'object') {
				this.formData[effectiveCategory] = {};
			}
			let summaryProperty = $(FormConfig.selectors.areaTypeSelect).eq(0).data('property') || 'roofAreaSummary';
			if (!this.formData[effectiveCategory].hasOwnProperty(summaryProperty)) {
				this.formData[effectiveCategory][summaryProperty] = null;
			}
			this.formData[effectiveCategory][summaryProperty] = this.getSpecialRoofAreaSummary();
		}

		if (special === 'infiltrationType') {
			this.infiltrationTypeChange(parseInt(value))
		}

		if (special === 'resilience') {
			this.resilienceChange($(field));
		}

		if (special === 'permittedDischarge' && parseInt(value) > 0) {
			const unit = $(FormConfig.selectors.permittedDischargeUnitInput)[0].selectedOptions[0].textContent;
			this.formData[category][property] = `${value} ${unit}`;
		}

		if (
			special === 'newGuideline' &&
			this.state.country !== FormConfig.values.countries.GERMANY
		) {
			delete this.formData[category];
		}
	}

	getSpecialInstallationSituationSummary() {
		const fields = [
			$(FormConfig.selectors.availableLength),
			$(FormConfig.selectors.availableWidth),
			$(FormConfig.selectors.groundwaterDistance),
			$(FormConfig.selectors.channelConnectionHeight)
		];

		// VSO-489: omit the rain frequency while it is disabled (DWA-A 138-1)
		const $rainFrequencySelect = $(FormConfig.selectors.rainFrequencySelect);
		let summary = $rainFrequencySelect.prop('disabled')
			? ''
			: `${$rainFrequencySelect.find(':selected').text()}<br>`;
		let anyFieldFilled = false;

		for (let i in fields) {
			const field = fields[i],
				value = field.val();
			if (value && value !== '0') {
				summary += `${field.data('speciallabel')} ${value} | `;
				anyFieldFilled = true;
			}
		}
		if (anyFieldFilled) {
			return summary.substring(0, summary.length - 2);
		}
		return '';
	}

	getSpecialRoofAreaSummary() {
		// If the new 138-1 UI is active, build summary as: "xxm² | Flächenart | Flächentyp"
		const blocks1381 = $(FormConfig.selectors.areaTypeBlock1381);
		if (this.isGuideline1381Active() && blocks1381.length) {
			// Only show after user reached this slide
			const slideIndex = $('#areaGuideline1381').parents(FormConfig.selectors.slides).data('slideindex');
			if (parseInt(slideIndex) > this.slideProgress) {
				return '';
			}
			let summary1381 = [];
			blocks1381.each((index, el) => {
				const $b = $(el);
				const areaVal = ($b.find(FormConfig.selectors.areaInput).val() || '').trim();
				const $cat = $b.find(FormConfig.selectors.surfaceCategory1381);
				const catText = $cat.length ? ($cat.find(':selected').text() || '').trim() : '';
				let typeText = '';
				if ($cat.length && $cat.val() === 'manual') {
					typeText = ($b.find(FormConfig.selectors.surfaceType1381Input).val() || '').trim();
				} else {
					typeText = ($b.find(FormConfig.selectors.surfaceType1381Select).find(':selected').text() || '').trim();
				}

				let parts = [];
				if (areaVal) {
					parts.push(`${areaVal}m²`);
				}
				if (catText) {
					parts.push(catText);
				}
				if (typeText) {
					parts.push(typeText);
				}
				if (parts.length && areaVal) {
					summary1381.push(parts.join(' | '));
				}
			});
			return summary1381;
		}

		// Fallback: old path (DWA-A 138)
		const blocks = $(FormConfig.selectors.areaTypeBlock);
		let summary = [];

		blocks.each((index, block) => {
			let summaryLine = '',
				$block = $(block),
				fields = [
					$block.find(FormConfig.selectors.areaInput),
					$block.find(FormConfig.selectors.coefficientSelect),
					$block.find(FormConfig.selectors.areaTypeSelect),
					$block.find(FormConfig.selectors.runofftypeSelect)
				];

			for (let i in fields) {
				const field = fields[i];
				let value = field.val();

				if (field.prop('tagName') === 'SELECT') {
					value = field.find(':selected').text();
				}

				if (value && value !== '0') {
					if (parseInt(i) === 0) {
						value += 'm²';
					}

					summaryLine += `${value} | `;
				}
			}

			if (fields[0].val()) {
				summary.push(summaryLine.substring(0, summaryLine.length - 2));
			}
		});

		return summary;
	}

	toggleFormDataRadio(field, category, property, deselect = true) {
		const value = $(field).data('value'),
			container = $(field).parents(FormConfig.selectors.checkboxRoot),
			propertyInputs = $(`[data-property="${property}"]`);

		if (deselect) {
			propertyInputs.each((i, input) => {
				$(input).parents(FormConfig.selectors.checkboxRoot).removeClass('checked');
			});
		}

		if (field.checked) {
			container.addClass('checked');
			this.formData[category][property] = value;
		}
	}

	toggleFormDataCheckbox(field, category, property) {
		if (typeof this.formData[category][property] !== "undefined") {
			const value = $(field).data('value'),
				container = $(field).parents(`${FormConfig.selectors.checkboxRoot}, ${FormConfig.selectors.squareCheckboxRoot}`);

			if (!field.checked) {
				container.removeClass('checked');
				// Remove all occurrences of value to avoid leftovers/duplicates
				this.formData[category][property] = this.formData[category][property].filter(v => v !== value);
			} else {
				container.addClass('checked');
				// Prevent duplicate pushes
				if (!this.formData[category][property].includes(value)) {
					this.formData[category][property].push(value);
				}
			}
		}
	}

	updateSummary() {
		this.configurationSummary.html('');
		// get labels for fOrt and fMethode (those are keys in formData)
		const fKLabel = $('.fKValue').data('property');
		const fOrtLabel = $('.fortValue').data('property');
		const fMethodeLabel = $('.fMethodeValue').data('property');
		// get states of ki and fK
		const kiIsManual = this.kiWizardManager ? this.kiWizardManager.getDecision() === 1 : false;
		const fKIsManual = this.fkWizardManager ? this.fkWizardManager.getDecision() === 1 : false;
		// check if properties should be skipped
		const skipProperties = [];
		// skip fOrt and fMethode if ki or fK is manual
		if (kiIsManual || fKIsManual) {
			skipProperties.push(fOrtLabel, fMethodeLabel);
		}
		// also skip fK if ki is manual
		if (kiIsManual) {
			skipProperties.push(fKLabel);
		}

		for (let category in this.formData) {
			let renderCategory = Object.values(this.formData[category]).some(
				value => {
					if (Array.isArray(value)) {
						return value.length;
					}
					return value !== null && value !== "" && value !== 0 && value !== "0";
				}
			);

			if (renderCategory) {
				this.configurationSummary.append(`<p class="summaryCategory">${category}</p>`);

				for (let property in this.formData[category]) {
					if (skipProperties.includes(property)) {
						continue;
					}
					let value = this.formData[category][property];

					if (Array.isArray(value)) {
						value = value.join('<br>');
					}
					if (value !== null && value !== "" && value !== 0 && value !== "0") {
						this.configurationSummary.append(
							`<div class="summaryItem" data-summaryproperty="${property}"><p class="summaryProperty">${property}</p><p class="summaryValue">${value}</p></div>`
						);
					}
				}
			}
		}

		const summaryProperties = $('.summaryItem');
		summaryProperties.off('click');
		summaryProperties.on('click', e => {
			const property = $(e.delegateTarget).data('summaryproperty');
			let targetSlide = null;
			const firstMatchingInput = this.form.find(`[data-property="${property}"]`).eq(0);
			if (firstMatchingInput.length) {
				targetSlide = parseInt(firstMatchingInput.parents(FormConfig.selectors.slides).data('slideindex'));
			}
			if (targetSlide !== null && !isNaN(targetSlide)) {
				this.goToSlide(targetSlide);
			}
		});
	}

	// Legacy area handlers moved to AreaManagerLegacy (Modules/AreaManagerLegacy.js)

	bindPermittedDischargeHandlers() {
		const
			permittedDischarge = $(FormConfig.selectors.permittedDischargeInput),
			permittedDischargeUnit = $(FormConfig.selectors.permittedDischargeUnitInput),
			rainDrainage = $(FormConfig.selectors.rainDrainageInput),
			rainDrainageArea = $(FormConfig.selectors.rainDrainageAreaInput),
			ignorePermittedDischarge = $(FormConfig.selectors.ignorePermittedDischargeCheckbox);

		// Initialize and check, if values exist (form was submitted)
		if (rainDrainageArea.val() > 0 && rainDrainage.val() > 0) {
			permittedDischarge.prop('disabled', true);
		} else if (permittedDischarge.val() > 0) {
			rainDrainage.prop('disabled', true);
			rainDrainageArea.prop('disabled', true);
		}
		if (permittedDischargeUnit.val() == 1) {
			permittedDischarge.prop('placeholder', permittedDischarge.data('placeholder-lmin'));
		}

		// Change placeholder if unit is changed
		permittedDischargeUnit.on('change keyup', e => {
			this.validatePermittedDischarge();

			if (permittedDischargeUnit.val() == 1) {
				permittedDischarge.prop('placeholder', permittedDischarge.data('placeholder-lmin'));
			} else {
				permittedDischarge.prop('placeholder', permittedDischarge.data('placeholder-ls'));
			}
			this.updateFormData(permittedDischarge[0]);
		});
		// Validate permittedDischarge if ignorePermittedDischarge is changed
		ignorePermittedDischarge.on('click', e => {
			this.validatePermittedDischarge();
		});

		// Disable rainDrainage if permittedDischarge is changed
		permittedDischarge.on('change keyup', e => {
			this.validatePermittedDischarge();

			if (permittedDischarge.val() === '' || permittedDischarge.val() == 0) {
				rainDrainage.prop('disabled', false);
				rainDrainageArea.prop('disabled', false);
			} else {
				rainDrainage.prop('disabled', true);
				rainDrainageArea.prop('disabled', true);
			}
		});
		// Disable permittedDischarge if rainDrainage is changed
		rainDrainage.on('change keyup', e => {
			if (rainDrainage.val() === '' || rainDrainage.val() == 0) {
				permittedDischarge.prop('disabled', false);
			} else {
				permittedDischarge.prop('disabled', true);
			}
		});
	}

	validatePermittedDischarge() {
		const
			permittedDischarge = $(FormConfig.selectors.permittedDischargeInput),
			permittedDischargeUnit = $(FormConfig.selectors.permittedDischargeUnitInput),
			rainDrainageInput = $(FormConfig.selectors.rainDrainageInput),
			rainDrainageAreaInput = $(FormConfig.selectors.rainDrainageAreaInput),
			ignorePermittedDischarge = $(FormConfig.selectors.ignorePermittedDischargeCheckbox),
			permittedDischargeError = $(FormConfig.selectors.permittedDischargeError);

		if (ignorePermittedDischarge.is(':checked')) {
			permittedDischarge.prop('required', false);
			rainDrainageInput.prop('required', false);
			rainDrainageAreaInput.prop('required', false);
		} else {
			permittedDischarge.prop('required', true);
			rainDrainageInput.prop('required', true);
			rainDrainageAreaInput.prop('required', true);
		}

		if (ignorePermittedDischarge.is(':checked') || permittedDischarge.val() === '' || permittedDischarge.val() == 0) {
			permittedDischargeError.remove();
			return;
		}

		let inputVal = parseFloat(permittedDischarge.val().replace(",", ".")),
			min = permittedDischarge.data('min-ls'),
			max = permittedDischarge.data('max-ls'),
			errorMessage = permittedDischarge.data('placeholder-ls');
		if (permittedDischargeUnit.val() == 1) {
			min = permittedDischarge.data('min-lmin');
			max = permittedDischarge.data('max-lmin');
			errorMessage = permittedDischarge.data('placeholder-lmin');
		}

		if (inputVal < min || inputVal > max) {
			permittedDischargeError.remove();
			permittedDischarge.after('<p class="error" id="permittedDischargeError">' + errorMessage + '</p>');
		} else {
			permittedDischargeError.remove();
		}
	}

	/**
	 * Switch infiltrationType dependent form fields
	 * Also disable products based on infiltration type (and resilience)
	 *
	 * @param infiltrationType
	 * @param activeSelection bool
	 */
	infiltrationTypeChange(infiltrationType, activeSelection = false) {
		if ([FormConfig.values.infiltrationType.RIGOLE, FormConfig.values.infiltrationType.TROUGH_RIGOLE].includes(infiltrationType)) {
			$(FormConfig.selectors.rigoleOnly).show();
			$(FormConfig.selectors.retentionOnly).hide();
			// disable all retention fields so they do not get submitted
			$(FormConfig.selectors.retentionOnly + ' input').prop('disabled', true);
			// enable rigole related inputs again (incl. guideline radios)
			$(FormConfig.selectors.rigoleOnly + ' input').not('[data-infiltrationnotpossible="1"]').prop('disabled', false);
			$(FormConfig.selectors.soilTypeInputs).prop('required', true);
			// guidelines logic (also see LocationManager -> countryChange)
			// force all countries except germany into legacy guideline
			if (this.state.country !== FormConfig.values.countries.GERMANY) {
				// preselect legacy guideline and disable guidelines selection for other countries
				$(FormConfig.selectors.legacyGuidelineRadio).click();
				$(FormConfig.selectors.legacyGuidelineRadio).parents(FormConfig.selectors.slides).data('skip', true);
			} else {
				$(FormConfig.selectors.legacyGuidelineRadio).parents(FormConfig.selectors.slides).data('skip', false);
			}
		}

		if (FormConfig.values.infiltrationType.RETENTION_CISTERN === infiltrationType) {
			if (activeSelection) {
				this.clearSlides(
					$(FormConfig.selectors.productSelectionSlide).nextAll(FormConfig.selectors.slides)
				);
			}
			$(FormConfig.selectors.retentionOnly).show();
			$(FormConfig.selectors.retentionOnly + ' input').not('[data-infiltrationnotpossible="1"]').prop('disabled', false);
			$(FormConfig.selectors.rigoleOnly).hide();
			// disable all rigole fields so they do not get submitted
			$(FormConfig.selectors.rigoleOnly + ' input').prop('disabled', true);
			// clear guideline selection since it is not relevant for retention
			this.form.find(FormConfig.selectors.newGuidelineRadios).prop('checked', false);
			// Also clear any visual selection state on the guideline radio wrappers to avoid UI/validation mismatch
			this.form.find(FormConfig.selectors.newGuidelineRadios).each((i, el) => {
				$(el).parents(FormConfig.selectors.checkboxRoot).removeClass('checked');
			});
			// Also remove the guideline entry from the sidebar summary data
			const $firstGuideline = this.form.find(FormConfig.selectors.newGuidelineRadios).eq(0);
			if ($firstGuideline.length) {
				const guidelineProperty = $firstGuideline.data('property');
				const guidelineCategory = $firstGuideline.parents(FormConfig.selectors.slides).data('category');
				if (
					guidelineProperty &&
					guidelineCategory &&
					this.formData[guidelineCategory] &&
					typeof this.formData[guidelineCategory][guidelineProperty] !== 'undefined'
				) {
					delete this.formData[guidelineCategory][guidelineProperty];
				}
			}
			// Clear validation errors on slides that are not relevant for retention (contain rigoleOnly content)
			// to prevent error-only slides from appearing when navigating.
			const rigoleSlides = this.slides.filter((i, el) => $(el).find(FormConfig.selectors.rigoleOnly).length > 0);
			rigoleSlides.find(FormConfig.selectors.errorList).hide().find('ul').html('');
			rigoleSlides.find('input, select, textarea').removeClass('error');
			$(FormConfig.selectors.soilTypeInputs).prop('required', false);
		}

		// VSO-309: add rainwater utilisation also to rigole
		if ([FormConfig.values.infiltrationType.RIGOLE, FormConfig.values.infiltrationType.RETENTION_CISTERN].includes(infiltrationType)) {
			$(FormConfig.selectors.rainwaterUtilisationOnly).show();
			$(FormConfig.selectors.rainwaterUtilisationOnly + ' input').prop('disabled', false);
			// only activate attenuationPlus inputs if checkbox is checked!
			if ($(FormConfig.selectors.attenuationPlusCheckbox).prop('checked') !== true) {
				$(FormConfig.selectors.attenuationPlusRow + ' input').prop('disabled', true);
			}
		} else {
			$(FormConfig.selectors.rainwaterUtilisationOnly).hide();
			// disable all rainwater utilisation fields so they do not get submitted
			$(FormConfig.selectors.rainwaterUtilisationOnly + ' input').prop('disabled', true);
		}

		if (activeSelection) {
			// deselect previously selected product types
			const productCheckboxes = $(FormConfig.selectors.productCheckbox + ':checked')
				.add($(FormConfig.selectors.retentionProductCheckbox + ':checked'));

			productCheckboxes.each((i, field) => {
				const category = $(field).parents(FormConfig.selectors.slides).data('category'),
					property = $(field).data('property');

				$(field).prop('checked', false);
				this.toggleFormDataCheckbox(field, category, property);
			});
		}

		// disable products based on infiltration type and resilience
		let $resilienceId = $(FormConfig.selectors.resilienceRadio + ':checked').val();
		this.updateDisabledProducts($resilienceId, infiltrationType);

		// VSO-409: Restore wizard step visibilities/skips after infiltrationTypeChange
		// which might have pauschally re-enabled inputs in rigoleOnly slides.
		if (this.kiWizardManager) this.kiWizardManager.updateVisibility();
		if (this.fkWizardManager) this.fkWizardManager.updateVisibility();
		if (this.fOrtQuestionManager) this.fOrtQuestionManager.updateVisibility();
		if (this.fMethodeManager) this.fMethodeManager.updateVisibility();

		// VSO-489: covers Mulden-Rigole <-> Rigole/Retention switches while 138-1 stays selected
		this.updateRainFrequencyDisabledState();

		// Always refresh the summary to immediately reflect changes
		// such as cleared guideline selection or product switches.
		this.updateSummary();
	}

	// Show additional fields if attenuation plus is checked and not disabled
	attenuationPlusChange(checkbox) {
		if (!checkbox.prop('disabled') && checkbox.prop('checked')) {
			$(FormConfig.selectors.attenuationPlusRow).show();
			$(FormConfig.selectors.attenuationPlusRow + ' input').prop('disabled', false);
		} else {
			$(FormConfig.selectors.attenuationPlusRow).hide();
			// disable fields so they do not get submitted
			$(FormConfig.selectors.attenuationPlusRow + ' input').prop('disabled', true);
		}
	}

	setCustomRunoffValueIndexNotation() {
		let significand = parseFloat(this.customRunoffValueInput.val());

		if (significand > 0) {
			let exponent = 0;

			while (significand < 1 && exponent > -6) {
				significand *= 10;
				exponent--;
			}

			this.customRunoffValueSignificand.val(MathUtility.formatFloat(Math.round(significand * 100) / 100));
			this.customRunoffValueExponent.val(exponent);
		}
	}

	resolveCustomRunoffValueIndexNotation(returnRaw = false) {
		const rawSignificand = String(this.customRunoffValueSignificand.val() || '').trim().replace(',', '.');
		const rawExponent = String(this.customRunoffValueExponent.val() || '').trim();

		const significandNum = parseFloat(rawSignificand);

		if (significandNum >= 1 && significandNum <= 9.9) {
			this.customRunoffValueInput.prev('input').prop('checked', true);

			const value = MathUtility.resolveIndexNotation(rawSignificand, rawExponent);
			const formattedValue = MathUtility.formatFloat(value);

			this.customRunoffValueInput.val(formattedValue);
			this.runoffValueIndexNotationResult.html(`(${formattedValue})`);

			if (returnRaw) {
				return value;
			}
			return formattedValue;
		} else {
			this.customRunoffValueInput.val(0);
			this.runoffValueIndexNotationResult.html('');
			return '';
		}
	}

	// CHANGE: fillCmCsSelect moved to AreaManagerNew (DWA-A 138-1) to keep it close to usage and
	// avoid additional back-dependency on the host. Behaviour unchanged.

	createOptionElement(value, label, additionalAttributes = []) {
		let option = document.createElement('option');
		option.setAttribute('value', value);
		option.innerHTML = label;

		additionalAttributes.forEach(attribute => {
			option.setAttribute(attribute.key, attribute.value);
		});

		return option;
	}

	/**
	 * Resilience info should be on page
	 *
	 * @param $field selected resilience checkbox
	 */
	resilienceChange($field) {
		let infiltrationTypeId = parseInt($(FormConfig.selectors.infiltrationType + ':checked').val());
		if (infiltrationTypeId && $field && $field.prop('checked')) {
			this.updateDisabledProducts(parseInt($field.val()), infiltrationTypeId);
		}
	}

	/**
	 * Disable products based on resilience and infiltration type
	 *
	 * @param resilience
	 * @param infiltrationType
	 */
	updateDisabledProducts(resilience, infiltrationType) {
		// Enable all products
		let $productCheckboxes = $(FormConfig.selectors.productCheckbox);
		$productCheckboxes.prop('disabled', '');
		$productCheckboxes.parents('.checkbox-wrapper').removeClass('disabled');

		// Disable products based on resilience
		if (typeof disableResiliences !== 'undefined') {
			$productCheckboxes.each((index, element) => {
				if (disableResiliences[element.value] !== undefined && disableResiliences[element.value].indexOf(parseInt(resilience)) > -1) {
					$(element).prop('disabled', true);
					$(element).parents('.checkbox-wrapper').addClass('disabled');
				}
			});
		}

		// Disable products based on infiltrationType
		if (typeof disableProducts !== 'undefined' && disableProducts[infiltrationType] !== undefined) {
			disableProducts[infiltrationType].forEach((element) => {
				$('#product' + element).prop('disabled', true);
			});
		}
	}

	updateProcessorSelect(team) {
		AjaxUtility.request('Administration', {
			controller: 'Configuration',
			action: 'getTeamMembers',
			team: team
		}).done(response => {
			let $processorSelect = $(FormConfig.selectors.processorSelect),
				members = JSON.parse(response),
				// keep the current processor selected if they are a member of the new team
				currentProcessor = $processorSelect.val();
			$processorSelect[0].length = 0;

			for (const key in members) {
				$processorSelect[0].options.add(
					this.createOptionElement(key, members[key])
				);
			}

			if (currentProcessor && members.hasOwnProperty(currentProcessor)) {
				$processorSelect.val(currentProcessor);
			}
		});
	}

	// Keep delegate method to process this[action]() within goToSlide method
	setWeatherStationManually() {
		// Delegate to LocationManager
		if (this.locationManager) {
			this.locationManager.setWeatherStationManually();
		}
	}

	activateGroundReportFilesUpload() {
		$(FormConfig.selectors.groundReportFilesUploadHidden).prop('checked', true);
		$(FormConfig.selectors.soilTypeSelectionContainer).hide().find('input')
			.prop('checked', false)
			.prop('required', false);
		$(FormConfig.selectors.groundReportFilesUploadNotification).show();
		this.customRunoffValueInput.val('');
		this.customRunoffValueSignificand.val('');
		this.customRunoffValueExponent[0].selectedIndex = 0;
		this.resolveCustomRunoffValueIndexNotation();
	}

	deactivateGroundReportFilesUpload() {
		$(FormConfig.selectors.groundReportFilesUploadHidden).prop('checked', false);
		$(FormConfig.selectors.soilTypeSelectionContainer).hide().find('input').prop('required', true);
		$(FormConfig.selectors.soilTypeSelectionContainer).show();
		$(FormConfig.selectors.groundReportFilesUploadNotification).hide();
	}

	customerTypeBasedToggles(customerType) {
		// toggle company input
		const companyInput = $(FormConfig.selectors.companyInput);

		// if is type end customer
		if (customerType === FormConfig.values.customerTypes.END_CUSTOMER) {
			companyInput.val('');
			companyInput.hide();
		} else {
			companyInput.show();
		}

		// toggle graf-partner row
		const grafPartnerRow = $(FormConfig.selectors.grafPartnerRow);
		const grafPartnerCheckbox = $(FormConfig.selectors.grafPartnerCheckbox);

		// if is type end customer or processor
		if (customerType === FormConfig.values.customerTypes.END_CUSTOMER || customerType === FormConfig.values.customerTypes.PROCESSORS) {
			grafPartnerRow.show();
			$(FormConfig.selectors.grafPartnerRow + ' input').prop('disabled', false);
			// only activate partner input if checkbox is checked!
			if (grafPartnerCheckbox.prop('checked') !== true) {
				$(FormConfig.selectors.grafPartnerInput).prop('disabled', true);
			}
		} else {
			grafPartnerRow.hide();
			$(FormConfig.selectors.grafPartnerRow + ' input').prop('disabled', true);
		}
	}

	grafPartnerCheckboxToggle(checked) {
		const grafPartnerInput = $(FormConfig.selectors.grafPartnerInput);
		if (checked) {
			grafPartnerInput.show();
			grafPartnerInput.prop('disabled', false);
		} else {
			grafPartnerInput.hide();
			grafPartnerInput.prop('disabled', true);
		}
	}

	equalizeCheckboxDescriptions() {
		$('[data-equalizedescriptions]').each((index, container) => {
			const descriptions = $(container).find(FormConfig.selectors.checkboxDescription);
			descriptions.css('height', '');
			const maxHeight = descriptions.toArray().reduce(
				(carry, description) => Math.max(carry, description.clientHeight), 0
			);
			descriptions.css('height', maxHeight);
		});
	}
}
